import { useState, useEffect } from "react";
import { Share2, User, Mail, MessageSquare, Send } from "lucide-react";
import { useNavigate } from "react-router-dom";
import SocialLinks from "../components/SocialLinks";
import Komentar from "../components/Commentar";
import Swal from "sweetalert2";
import AOS from "aos";
import "aos/dist/aos.css";
import { AutoAwesomeOutlined } from "@mui/icons-material";

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({
      once: false,
    });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    Swal.fire({
      title: "Sending Message...",
      html: "Please wait while we send your message",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      let response = await fetch("https://formsubmit.co/qaiserejaz125@gmail.com", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        response = await fetch("https://formsubmit.co/bejiyu", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        });

        if (!response.ok) {
          response = await fetch("https://formsubmit.co/qaisersiddiqui121@gmail.com", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
          });

          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
        }
      }

      Swal.fire({
        title: "Success!",
        text: "Your message has been sent successfully!",
        icon: "success",
        confirmButtonColor: "#6366f1",
        timer: 2000,
        timerProgressBar: true,
        didClose: () => {
          navigate("/thank-you");
        },
      });

      setFormData({
        name: "",
        email: "",
        message: "",
      });
    } catch (error) {
      console.error(error);
      Swal.fire({
        title: "Error!",
        text: "Something went wrong. Please try again later.",
        icon: "error",
        confirmButtonColor: "#6366f1",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="Contact" className="py-16 relative">
      <div className="text-center mt-10 sm:mt-[5%] mb-2 px-[5%] sm:px-0">
        <h2
          data-aos="fade-down"
          data-aos-duration="1000"
          className="inline-block text-2xl sm:text-3xl md:text-5xl font-bold text-center mx-auto text-transparent bg-clip-text bg-gradient-to-r from-[#6366f1] to-[#a855f7]"
        >
          <span
            style={{
              color: "#6366f1",
              backgroundImage: "linear-gradient(45deg, #6366f1 10%, #a855f7 93%)",
              WebkitBackgroundClip: "text",
              backgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            Contact Me
          </span>
        </h2>
        <div
          className="mt-4 sm:mt-6 text-gray-400 max-w-xl sm:max-w-2xl mx-auto text-sm sm:text-base flex items-center justify-center gap-2"
          data-aos="zoom-in-up"
          data-aos-duration="800"
        >
          <div className="relative group">
            <div className="absolute -inset-0.5 bg-gradient-to-r from-[#6366f1] to-[#a855f7] rounded-full blur opacity-30 group-hover:opacity-50 transition duration-1000"></div>
            <div className="relative px-2 sm:px-4 py-1 sm:py-2 rounded-full bg-black/40 backdrop-blur-xl border border-white/10">
              <span className="bg-gradient-to-r from-[#6366f1] to-[#a855f7] text-transparent bg-clip-text text-xs sm:text-sm font-medium flex items-center">
                <AutoAwesomeOutlined className="w-4 h-4 sm:w-5 sm:h-5 mr-1 sm:mr-2 text-purple-400" />
                Got a question? Send me a message!
                <AutoAwesomeOutlined className="w-4 h-4 sm:w-5 sm:h-5 ml-1 sm:ml-2 text-purple-400" />
              </span>
            </div>
          </div>
        </div>
      </div>

      <div
        className="h-auto py-6 sm:py-10 flex items-center justify-center px-[5%] md:px-0"
        id="Contact"
      >
        <div className="container px-[1%] sm:px-[2%] md:px-[5%] grid grid-cols-1 lg:grid-cols-[49%_49%] 2xl:grid-cols-[39%_59%] gap-6 sm:gap-10">
          <div
            data-aos="fade-right"
            data-aos-duration="1200"
            className="bg-white/5 backdrop-blur-xl rounded-2xl sm:rounded-3xl shadow-xl p-3 sm:p-5 md:p-10 transform transition-all duration-300 hover:shadow-[#6366f1]/10"
          >
            <div className="flex justify-between items-start mb-4 sm:mb-8">
              <div>
                <h2 className="text-2xl sm:text-4xl font-bold mb-2 sm:mb-3 text-transparent bg-clip-text bg-gradient-to-r from-[#6366f1] to-[#a855f7]">
                  Get in Touch
                </h2>
                <div className="text-gray-400 text-xs sm:text-sm">
                  Have something to discuss? Send me a message.
                </div>
              </div>
              <Share2 className="w-6 h-6 sm:w-10 sm:h-10 text-[#6366f1] opacity-50" />
            </div>

            <form onSubmit={handleSubmit} className="space-y-4 sm:space-y-6">
              {/* FormSubmit Configuration */}
              <input type="hidden" name="_template" value="table" />
              <input type="hidden" name="_captcha" value="false" />
              <label htmlFor="name" className="hidden text-sm font-medium text-gray-300 mb-1">
                  Name
                </label>
              <div
                data-aos="fade-up"
                data-aos-delay="100"
                className="relative group"
              >
                <User className="absolute left-3 sm:left-4 top-3 sm:top-4 w-4 h-4 sm:w-5 sm:h-5 text-gray-400 group-focus-within:text-[#6366f1] transition-colors" />
                
                <input
                  type="text"
                  id="name"
                  name="name"
                  placeholder="Your Name"
                  value={formData.name}
                  onChange={handleChange}
                  disabled={isSubmitting}
                  autoComplete="name"
                  className="w-full p-3 sm:p-4 pl-10 sm:pl-12 bg-white/10 rounded-xl border border-white/20 placeholder-gray-500 text-white focus:outline-none focus:ring-2 focus:ring-[#6366f1]/30 transition-all duration-300 hover:border-[#6366f1]/30 disabled:opacity-50 text-xs sm:text-sm"
                  required
                />
              </div>
              <label htmlFor="email" className="hidden text-sm font-medium text-gray-300 mb-1">
                Email
              </label>
              <div
                data-aos="fade-up"
                data-aos-delay="130"
                className="relative group"
              >
                <Mail className="absolute left-3 sm:left-4 top-3 sm:top-4 w-4 h-4 sm:w-5 sm:h-5 text-gray-400 group-focus-within:text-[#6366f1] transition-colors" />
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="Your Email"
                  value={formData.email}
                  onChange={handleChange}
                  disabled={isSubmitting}
                  autoComplete="email"
                  className="w-full p-3 sm:p-4 pl-10 sm:pl-12 bg-white/10 rounded-xl border border-white/20 placeholder-gray-500 text-white focus:outline-none focus:ring-2 focus:ring-[#6366f1]/30 transition-all duration-300 hover:border-[#6366f1]/30 disabled:opacity-50 text-xs sm:text-sm"
                  required
                />
              </div>
              <label htmlFor="message" className="hidden text-sm font-medium text-gray-300 mb-1">
                Message
              </label>
              <div
                data-aos="fade-up"
                data-aos-delay="170"
                className="relative group"
              >
                <MessageSquare className="absolute left-3 sm:left-4 top-3 sm:top-4 w-4 h-4 sm:w-5 sm:h-5 text-gray-400 group-focus-within:text-[#6366f1] transition-colors" />
                <textarea
                  id="message"
                  name="message"
                  placeholder="Your Message"
                  value={formData.message}
                  onChange={handleChange}
                  disabled={isSubmitting}
                  autoComplete="off"
                  className="w-full resize-none p-3 sm:p-4 pl-10 sm:pl-12 bg-white/10 rounded-xl border border-white/20 placeholder-gray-500 text-white focus:outline-none focus:ring-2 focus:ring-[#6366f1]/30 transition-all duration-300 hover:border-[#6366f1]/30 h-[6rem] sm:h-[9.9rem] disabled:opacity-50 text-xs sm:text-sm"
                  required
                  rows={4}
                />
              </div>

              <button
                id="submit"
                data-aos="fade-up"
                data-aos-delay="200"
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-gradient-to-r from-[#6366f1] to-[#a855f7] text-white py-3 sm:py-4 rounded-xl font-semibold transition-all duration-300 hover:scale-[1.02] hover:shadow-lg hover:shadow-[#6366f1]/20 active:scale-[0.98] flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100 text-xs sm:text-sm"
              >
                <Send className="w-4 h-4 sm:w-5 sm:h-5" />
                {isSubmitting ? "Sending..." : "Send Message"}
              </button>
            </form>

            <div className="mt-6 sm:mt-10 pt-4 sm:pt-6 border-t border-white/10 flex justify-center space-x-4 sm:space-x-6">
              <SocialLinks />
            </div>
          </div>

          <div
            data-aos="fade-left"
            data-aos-duration="1200"
            className="bg-white/5 backdrop-blur-xl rounded-2xl sm:rounded-3xl p-3 sm:p-5 md:p-10 shadow-xl transform transition-all duration-300 hover:shadow-[#6366f1]/10"
          >
            <Komentar />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactPage;